import { specials } from '../data';
import { SectionHeader } from './SectionHeader';

export default function Special() {
  return (
    <section id="special" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          kicker="焦点专题 · 深度观察"
          title="不只看热闹，也看懂门道"
          desc="除了把瓜聚齐，我们也试着把热度背后的逻辑捋清楚，用更冷静的视角陪你看完这一波又一波。"
        />

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-6">
          {specials.map((sp) => (
            <article
              key={sp.title}
              className="group overflow-hidden rounded-2xl border border-background-200 bg-background-100/50 transition-colors hover:border-primary-200"
            >
              <a href="#faq" className="block">
                <div className="relative h-44 overflow-hidden md:h-52">
                  <img
                    src={sp.img}
                    alt={sp.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-bold text-primary-600">
                    {sp.kicker}
                  </span>
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-xl">
                    {sp.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{sp.body}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                    阅读专题全文
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </div>
              </a>
            </article>
          ))}
        </div>

        <div className="mt-6 flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-accent-600 to-accent-500 px-5 py-6 text-background-50 sm:flex-row sm:items-center md:px-8">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-background-50/20 text-xl">
            <i className="ri-megaphone-line"></i>
          </div>
          <div className="flex-1">
            <h3 className="font-heading text-lg font-bold md:text-xl">有话想说？告诉我们今天漏了什么瓜</h3>
            <p className="mt-1 text-sm text-background-50/90">
              你的补充与纠错都会帮助我们把今天的动向整理得更完整、更准确。
            </p>
          </div>
          <a
            href="#footer"
            className="inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-semibold text-accent-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-chat-3-line"></i>来聊几句
          </a>
        </div>
      </div>
    </section>
  );
}